import {
  fetchReferralPartnerships,
  getCommissionStructure,
  getIntroducers,
  patchCommissionStructure,
  postCommissionStructure,
} from '../api/commission_structure'
import {
  MutationCreateCommissionStructureArgs,
  MutationUpdateCommissionStructureArgs,
  Resolvers,
} from '../generated/resolvers'

const CommissionStructureResolvers: Resolvers = {
  Query: {
    getCommissionStructures: async (_, args) => await getCommissionStructure(args),
    introducers: async (_, args) => await getIntroducers(args),
    getReferralPartners: async (_, args) => await fetchReferralPartnerships(args)
  },
  Mutation: {
    createCommissionStructure: (_, args: MutationCreateCommissionStructureArgs) => postCommissionStructure(args),
    updateCommissionStructure: (_, args: MutationUpdateCommissionStructureArgs) => patchCommissionStructure(args),
  },

}

export default CommissionStructureResolvers
